module.exports = __webpack_public_path__ + "static/media/loading.0a2df2d2.svg";